<template>
  <SvgoMonogramDrAlexisGranite :font-controlled="false" />
</template>
